import { render, staticRenderFns } from "./ProductHitches.vue?vue&type=template&id=28a5d1d2&"
import script from "./ProductHitches.vue?vue&type=script&lang=js&"
export * from "./ProductHitches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports